export async function flush({ commit }) {
  commit('flush');
}
